import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { sha256 } from 'js-sha256';
import { LoginSucceed } from '../models';
import { map, switchMap } from 'rxjs/operators';
import { ApiBaseService } from '../crud.service';

@Injectable()
export class LoginService extends ApiBaseService {
    constructor(protected httpClient: HttpClient) {
        super(httpClient);
    }

    login(username: string, password: string): Observable<LoginSucceed> {
        const unixTimeStamp = Date.now();
        const key = sha256(password + username);

        return this.httpClient.get('/request_ip').pipe(
            map((res: any) => res && res.data.ip),
            switchMap((ipAddress: string) => {
                return this.httpClient.post('/login', {
                    data: {
                        email: username,
                        password,
                        timestamp: unixTimeStamp,
                        ip_address: ipAddress,
                        key,
                        secret: sha256(key + unixTimeStamp + ipAddress),
                    },
                });
            }),
            map((res: any) => res.data)
        );
    }

    logOut(accessToken: string): Observable<boolean> {
        return this.httpClient.post<boolean>('/logout', {
            access_token: accessToken,
        });
    }
}
